const DUMMY_P = ['p-0', 'p-1', 'p-2', 'p-3', 'p-4', 'p-5', 'p-6', 'p-7', 'p-8', 'p-9', 'p-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_PY = ['py-0', 'py-1', 'py-2', 'py-3', 'py-4', 'py-5', 'py-6', 'py-7', 'py-8', 'py-9', 'py-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_PX = ['px-0', 'px-1', 'px-2', 'px-3', 'px-4', 'px-5', 'px-6', 'px-7', 'px-8', 'px-9', 'px-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_PT = ['pt-0', 'pt-1', 'pt-2', 'pt-3', 'pt-4', 'pt-5', 'pt-6', 'pt-7', 'pt-8', 'pt-9', 'pt-10'].map((item, index) => <option key={index} value={item}>{item}</option>)
const DUMMY_PB = ['pb-0', 'pb-1', 'pb-2', 'pb-3', 'pb-4', 'pb-5', 'pb-6', 'pb-7', 'pb-8', 'pb-9', 'pb-10'].map((item, index) => <option key={index} value={item}>{item}</option>)

const Padding = props => {
    return <div className="container fluid py-2" id="padding">

        <div className="container fluid">
            <p className="text xl"><a href="#padding" className="link">&#128279;</a> Padding</p>
            <p className="text md">
                Padding applies specific padding to an element defined in percentages.
        </p>
        </div>


        <div className="spacer md"></div>


        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                            <th>Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.p-0, .p-1, .p-2, .p-3, .p-4, .p-5, .p-6, .p-7, .p-8, .p-9, .p-10</code>
                            </td>
                            <td>Sets the padding on all sides of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the padding</label>
                                    <select onChange={(e) => props.helper('padding-display', `<div class='bg-primary' style='height: 100%;'></div>`, `h25 border-dark`, e)}>
                                        {DUMMY_P}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.py-0, .py-1, .py-2, .py-3, .py-4, .py-5, .py-6, .py-7, .py-8, .py-9, .py-10</code>
                            </td>
                            <td>Sets the padding on top & bottom sides of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the padding</label>
                                    <select onChange={(e) => props.helper('padding-display', `<div class='bg-primary' style='height: 100%;'></div>`, `h25 border-dark`, e)}>
                                        {DUMMY_PY}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.px-0, .px-1, .px-2, .px-3, .px-4, .px-5, .px-6, .px-7, .px-8, .px-9, .px-10</code>
                            </td>
                            <td>Sets the padding on left & right sides of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the padding</label>
                                    <select onChange={(e) => props.helper('padding-display', `<div class='bg-primary' style='height: 100%;'></div>`, `h25 border-dark`, e)}>
                                        {DUMMY_PX}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.pt-0, .pt-1, .pt-2, .pt-3, .pt-4, .pt-5, .pt-6, .pt-7, .pt-8, .pt-9, .pt-10</code>
                            </td>
                            <td>Sets the padding on top side of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the padding</label>
                                    <select onChange={(e) => props.helper('padding-display', `<div class='bg-primary' style='height: 100%;'></div>`, `h25 border-dark`, e)}>
                                        {DUMMY_PT}
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.pb-0, .pb-1, .pb-2, .pb-3, .pb-4, .pb-5, .pb-6, .pb-7, .pb-8, .pb-9, .pb-10</code>
                            </td>
                            <td>Sets the padding on bottom side of an element</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Change the padding</label>
                                    <select onChange={(e) => props.helper('padding-display', `<div class='bg-primary' style='height: 100%;'></div>`, `h25 border-dark`, e)}>
                                        {DUMMY_PB}
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container sm p-2">
            <div className="border-dark h25" id="padding-display">
                <div className="bg-primary" style={{ height: '100%' }}></div>
            </div>
        </div>


    </div>
}

export default Padding